// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suspense-loader-container {
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  animation: fadein 0.5s;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.suspense-loader-container .logo {
  height: 35px;
}
.suspense-loader-container .footnote {
  font-size: 16px;
  font-weight: 600;
  color: var(--secondary-color-1);
  font-family: "Proxima Nova", sans-serif;
}
.suspense-loader-container #loader-1-s-circle1_ts {
  animation: loader-1-s-circle1_ts__ts 8000ms linear infinite normal forwards;
}
@keyframes loader-1-s-circle1_ts__ts {
  0% {
    transform: translate(272.23px, 440.214782px) scale(0.035635, 0.035635);
  }
  6.25% {
    transform: translate(272.23px, 440.214782px) scale(0.035635, 0.035635);
  }
  13.75% {
    transform: translate(272.23px, 440.214782px) scale(1.228888, 1.228888);
  }
  41.25% {
    transform: translate(272.23px, 440.214782px) scale(0.091157, 0.091157);
  }
  100% {
    transform: translate(272.23px, 440.214782px) scale(0.091157, 0.091157);
  }
}
.suspense-loader-container #loader-1-s-circle2_ts {
  animation: loader-1-s-circle2_ts__ts 8000ms linear infinite normal forwards;
}
@keyframes loader-1-s-circle2_ts__ts {
  0% {
    transform: translate(1128.334792px, 181.854px) scale(0.058455, 0.058455);
  }
  70% {
    transform: translate(1128.334792px, 181.854px) scale(0.058455, 0.058455);
  }
  75% {
    transform: translate(1128.334792px, 181.854px) scale(0.493697, 0.493697);
  }
  85% {
    transform: translate(1128.334792px, 181.854px) scale(0.88886, 0.88886);
  }
  97.5% {
    transform: translate(1128.334792px, 181.854px) scale(0.018289, 0.018289);
  }
  100% {
    transform: translate(1128.334792px, 181.854px) scale(0.018289, 0.018289);
  }
}
.suspense-loader-container #loader-1-s-circle3_ts {
  animation: loader-1-s-circle3_ts__ts 8000ms linear infinite normal forwards;
}
@keyframes loader-1-s-circle3_ts__ts {
  0% {
    transform: translate(1034.957px, 490.76px) scale(-0.054759, -0.054759);
  }
  61.25% {
    transform: translate(1034.957px, 490.76px) scale(-0.054759, -0.054759);
  }
  72.5% {
    transform: translate(1034.957px, 490.76px) scale(-0.818553, -0.818553);
  }
  97.5% {
    transform: translate(1034.957px, 490.76px) scale(-0.027084, -0.027084);
  }
  100% {
    transform: translate(1034.957px, 490.76px) scale(-0.027084, -0.027084);
  }
}
.suspense-loader-container #loader-1-s-circle4_ts {
  animation: loader-1-s-circle4_ts__ts 8000ms linear infinite normal forwards;
}
@keyframes loader-1-s-circle4_ts__ts {
  0% {
    transform: translate(739.227358px, 499.267px) scale(0.086686, 0.086686);
  }
  43.25% {
    transform: translate(739.227358px, 499.267px) scale(0.086686, 0.086686);
  }
  46.25% {
    transform: translate(739.227358px, 499.267px) scale(0.843954, 0.843954);
  }
  65% {
    transform: translate(739.227358px, 499.267px) scale(0.055718, 0.055718);
  }
  100% {
    transform: translate(739.227358px, 499.267px) scale(0.055718, 0.055718);
  }
}
.suspense-loader-container #loader-1-s-circle5_ts {
  animation: loader-1-s-circle5_ts__ts 8000ms linear infinite normal forwards;
}
@keyframes loader-1-s-circle5_ts__ts {
  0% {
    transform: translate(807.507px, 250.356px) scale(0.037088, 0.037088);
  }
  45% {
    transform: translate(807.507px, 250.356px) scale(0.037088, 0.037088);
  }
  47.5% {
    transform: translate(807.507px, 250.356px) scale(1.188035, 1.188035);
  }
  70.5% {
    transform: translate(807.507px, 250.356px) scale(0.040227, 0.040227);
  }
  100% {
    transform: translate(807.507px, 250.356px) scale(0.040227, 0.040227);
  }
}
.suspense-loader-container #loader-1-s-circle6_ts {
  animation: loader-1-s-circle6_ts__ts 8000ms linear infinite normal forwards;
}
@keyframes loader-1-s-circle6_ts__ts {
  0% {
    transform: translate(543.96px, 198.868px) scale(-0.152288, -0.152288);
  }
  28.75% {
    transform: translate(543.96px, 198.868px) scale(-0.152288, -0.152288);
  }
  33.875% {
    transform: translate(543.96px, 198.868px) scale(-0.747354, -0.747354);
  }
  53.375% {
    transform: translate(543.96px, 198.868px) scale(-0.041885, -0.041885);
  }
  100% {
    transform: translate(543.96px, 198.868px) scale(-0.041885, -0.041885);
  }
}
.suspense-loader-container #loader-1-s-circle7_ts {
  animation: loader-1-s-circle7_ts__ts 8000ms linear infinite normal forwards;
}
@keyframes loader-1-s-circle7_ts__ts {
  0% {
    transform: translate(362px, 301.259px) scale(0.063979, 0.063979);
  }
  13.75% {
    transform: translate(362px, 301.259px) scale(0.063979, 0.063979);
  }
  20% {
    transform: translate(362px, 301.259px) scale(1.380506, 1.380505);
  }
  48.625% {
    transform: translate(362px, 301.259px) scale(0.059933, 0.059932);
  }
  100% {
    transform: translate(362px, 301.259px) scale(0.059933, 0.059932);
  }
}
.suspense-loader-container #loader-1-s-circle8_ts {
  animation: loader-1-s-circle8_ts__ts 8000ms linear infinite normal forwards;
}
@keyframes loader-1-s-circle8_ts__ts {
  0% {
    transform: translate(597.467px, 387.802px) scale(0.097074, 0.097074);
  }
  33.875% {
    transform: translate(597.467px, 387.802px) scale(0.097074, 0.097074);
  }
  36.25% {
    transform: translate(597.467px, 387.802px) scale(1.73358, 1.73358);
  }
  60% {
    transform: translate(597.467px, 387.802px) scale(-0.01359, -0.01359);
  }
  100% {
    transform: translate(597.467px, 387.802px) scale(-0.01359, -0.01359);
  }
}
.suspense-loader-container #loader-1-s-circle9_ts {
  animation: loader-1-s-circle9_ts__ts 8000ms linear infinite normal forwards;
}
@keyframes loader-1-s-circle9_ts__ts {
  0% {
    transform: translate(116.452px, 205.808px) scale(0.021473, 0.021473);
  }
  2.5% {
    transform: translate(116.452px, 205.808px) scale(1.252392, 1.252395);
  }
  37.5% {
    transform: translate(116.452px, 205.808px) scale(0.066386, 0.066386);
  }
  100% {
    transform: translate(116.452px, 205.808px) scale(0.066386, 0.066386);
  }
}
.suspense-loader-container #loader-1-s-circle10_ts {
  animation: loader-1-s-circle10_ts__ts 8000ms linear infinite normal forwards;
}
@keyframes loader-1-s-circle10_ts__ts {
  0% {
    transform: translate(859.452px, 383.295px) scale(0.052105, 0.052105);
  }
  47.5% {
    transform: translate(859.452px, 383.295px) scale(0.052105, 0.052105);
  }
  63.75% {
    transform: translate(859.452px, 383.295px) scale(1.218668, 1.218668);
  }
  87.5% {
    transform: translate(859.452px, 383.295px) scale(0.054, 0.054);
  }
  100% {
    transform: translate(859.452px, 383.295px) scale(0.054, 0.054);
  }
}
.suspense-loader-container #loader-1-u-bee_to {
  animation: loader-1-u-bee_to__to 8000ms linear infinite normal forwards;
}
@keyframes loader-1-u-bee_to__to {
  0% {
    offset-distance: 0%;
  }
  15.75% {
    offset-distance: 18.458343%;
  }
  34.875% {
    offset-distance: 36.648888%;
  }
  55.625% {
    offset-distance: 56.451111%;
  }
  71% {
    offset-distance: 71.141597%;
  }
  82.875% {
    offset-distance: 82.485581%;
  }
  99.375% {
    offset-distance: 100%;
  }
  100% {
    offset-distance: 100%;
  }
}
.suspense-loader-container #loader-1-u-bee_tr {
  animation: loader-1-u-bee_tr__tr 8000ms linear infinite normal forwards;
}
@keyframes loader-1-u-bee_tr__tr {
  0% {
    transform: rotate(118.65774deg);
  }
  1.25% {
    transform: rotate(122.202405deg);
  }
  3.5% {
    transform: rotate(115.372827deg);
  }
  5.75% {
    transform: rotate(109.358274deg);
  }
  11.875% {
    transform: rotate(70.265522deg);
  }
  13.5% {
    transform: rotate(57.596306deg);
  }
  15.75% {
    transform: rotate(45.92046deg);
  }
  17.125% {
    transform: rotate(40.69934deg);
  }
  18% {
    transform: rotate(38.696902deg);
  }
  20.375% {
    transform: rotate(35.180438deg);
  }
  26.125% {
    transform: rotate(39.907673deg);
  }
  29.875% {
    transform: rotate(60.940169deg);
  }
  34% {
    transform: rotate(83.531393deg);
  }
  38.75% {
    transform: rotate(121.711444deg);
  }
  42.25% {
    transform: rotate(138.523398deg);
  }
  48.625% {
    transform: rotate(135.099299deg);
  }
  50.125% {
    transform: rotate(126.406147deg);
  }
  53.375% {
    transform: rotate(79.459502deg);
  }
  57% {
    transform: rotate(40.496824deg);
  }
  57.25% {
    transform: rotate(35.479916deg);
  }
  60.5% {
    transform: rotate(21.078307deg);
  }
  63.875% {
    transform: rotate(23.165336deg);
  }
  65.25% {
    transform: rotate(30.066083deg);
  }
  66.75% {
    transform: rotate(50.796451deg);
  }
  68.75% {
    transform: rotate(70.467798deg);
  }
  72.875% {
    transform: rotate(112.40962deg);
  }
  76% {
    transform: rotate(174.372809deg);
  }
  79.5% {
    transform: rotate(236.317164deg);
  }
  82.375% {
    transform: rotate(295.031116deg);
  }
  85.625% {
    transform: rotate(374.12056deg);
  }
  88.75% {
    transform: rotate(406.175698deg);
  }
  92% {
    transform: rotate(434.926396deg);
  }
  95.75% {
    transform: rotate(482.621589deg);
  }
  100% {
    transform: rotate(501.210455deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SuspenseLoader/suspenseLoader.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AACJ;AAAI;EACI;IAAO,UAAA;EAGb;EAFM;IAAO,UAAA;EAKb;AACF;AAJI;EACI,YAAA;AAMR;AAJI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;AAMR;AAJI;EACI,2EAAA;AAMR;AAJI;EACI;IACI,sEAAA;EAMV;EAHM;IACI,sEAAA;EAKV;EAFM;IACI,sEAAA;EAIV;EADM;IACI,sEAAA;EAGV;EAAM;IACI,sEAAA;EAEV;AACF;AACI;EACI,2EAAA;AACR;AAEI;EACI;IACI,wEAAA;EAAV;EAGM;IACI,wEAAA;EADV;EAIM;IACI,wEAAA;EAFV;EAKM;IACI,sEAAA;EAHV;EAMM;IACI,wEAAA;EAJV;EAOM;IACI,wEAAA;EALV;AACF;AAQI;EACI,2EAAA;AANR;AASI;EACI;IACI,sEAAA;EAPV;EAUM;IACI,sEAAA;EARV;EAWM;IACI,sEAAA;EATV;EAYM;IACI,sEAAA;EAVV;EAaM;IACI,sEAAA;EAXV;AACF;AAcI;EACI,2EAAA;AAZR;AAeI;EACI;IACI,uEAAA;EAbV;EAgBM;IACI,uEAAA;EAdV;EAiBM;IACI,uEAAA;EAfV;EAkBM;IACI,uEAAA;EAhBV;EAmBM;IACI,uEAAA;EAjBV;AACF;AAoBI;EACI,2EAAA;AAlBR;AAqBI;EACI;IACI,oEAAA;EAnBV;EAsBM;IACI,oEAAA;EApBV;EAuBM;IACI,oEAAA;EArBV;EAwBM;IACI,oEAAA;EAtBV;EAyBM;IACI,oEAAA;EAvBV;AACF;AA0BI;EACI,2EAAA;AAxBR;AA2BI;EACI;IACI,qEAAA;EAzBV;EA4BM;IACI,qEAAA;EA1BV;EA6BM;IACI,qEAAA;EA3BV;EA8BM;IACI,qEAAA;EA5BV;EA+BM;IACI,qEAAA;EA7BV;AACF;AAgCI;EACI,2EAAA;AA9BR;AAiCI;EACI;IACI,gEAAA;EA/BV;EAkCM;IACI,gEAAA;EAhCV;EAmCM;IACI,gEAAA;EAjCV;EAoCM;IACI,gEAAA;EAlCV;EAqCM;IACI,gEAAA;EAnCV;AACF;AAsCI;EACI,2EAAA;AApCR;AAuCI;EACI;IACI,oEAAA;EArCV;EAwCM;IACI,oEAAA;EAtCV;EAyCM;IACI,kEAAA;EAvCV;EA0CM;IACI,oEAAA;EAxCV;EA2CM;IACI,oEAAA;EAzCV;AACF;AA4CI;EACI,2EAAA;AA1CR;AA6CI;EACI;IACI,oEAAA;EA3CV;EA8CM;IACI,oEAAA;EA5CV;EA+CM;IACI,oEAAA;EA7CV;EAgDM;IACI,oEAAA;EA9CV;AACF;AAiDI;EACI,4EAAA;AA/CR;AAkDI;EACI;IACI,oEAAA;EAhDV;EAmDM;IACI,oEAAA;EAjDV;EAoDM;IACI,oEAAA;EAlDV;EAqDM;IACI,8DAAA;EAnDV;EAsDM;IACI,8DAAA;EApDV;AACF;AAuDI;EACI,uEAAA;AArDR;AAwDI;EACI;IACI,mBAAA;EAtDV;EAyDM;IACI,2BAAA;EAvDV;EA0DM;IACI,2BAAA;EAxDV;EA2DM;IACI,2BAAA;EAzDV;EA4DM;IACI,2BAAA;EA1DV;EA6DM;IACI,2BAAA;EA3DV;EA8DM;IACI,qBAAA;EA5DV;EA+DM;IACI,qBAAA;EA7DV;AACF;AAgEI;EACI,uEAAA;AA9DR;AAiEI;EACI;IACI,+BAAA;EA/DV;EAkEM;IACI,gCAAA;EAhEV;EAmEM;IACI,gCAAA;EAjEV;EAoEM;IACI,gCAAA;EAlEV;EAqEM;IACI,+BAAA;EAnEV;EAsEM;IACI,+BAAA;EApEV;EAuEM;IACI,8BAAA;EArEV;EAwEM;IACI,8BAAA;EAtEV;EAyEM;IACI,+BAAA;EAvEV;EA0EM;IACI,+BAAA;EAxEV;EA2EM;IACI,+BAAA;EAzEV;EA4EM;IACI,+BAAA;EA1EV;EA6EM;IACI,+BAAA;EA3EV;EA8EM;IACI,gCAAA;EA5EV;EA+EM;IACI,gCAAA;EA7EV;EAgFM;IACI,gCAAA;EA9EV;EAiFM;IACI,gCAAA;EA/EV;EAkFM;IACI,+BAAA;EAhFV;EAmFM;IACI,+BAAA;EAjFV;EAoFM;IACI,+BAAA;EAlFV;EAqFM;IACI,+BAAA;EAnFV;EAsFM;IACI,+BAAA;EApFV;EAuFM;IACI,+BAAA;EArFV;EAwFM;IACI,+BAAA;EAtFV;EAyFM;IACI,+BAAA;EAvFV;EA0FM;IACI,+BAAA;EAxFV;EA2FM;IACI,gCAAA;EAzFV;EA4FM;IACI,gCAAA;EA1FV;EA6FM;IACI,gCAAA;EA3FV;EA8FM;IACI,+BAAA;EA5FV;EA+FM;IACI,gCAAA;EA7FV;EAgGM;IACI,gCAAA;EA9FV;EAiGM;IACI,gCAAA;EA/FV;EAkGM;IACI,gCAAA;EAhGV;AACF","sourcesContent":[".suspense-loader-container {\n    padding: 50px 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    animation: fadein .5s;\n    @keyframes fadein {\n        from { opacity: 0; }\n        to   { opacity: 1; }\n    }\n    .logo {\n        height: 35px;\n    }\n    .footnote {\n        font-size: 16px;\n        font-weight: 600;\n        color: var(--secondary-color-1);\n        font-family: 'Proxima Nova', sans-serif;\n    }\n    #loader-1-s-circle1_ts {\n        animation: loader-1-s-circle1_ts__ts 8000ms linear infinite normal forwards\n    }\n    @keyframes loader-1-s-circle1_ts__ts {\n        0% {\n            transform: translate(272.23px, 440.214782px) scale(0.035635, 0.035635)\n        }\n    \n        6.25% {\n            transform: translate(272.23px, 440.214782px) scale(0.035635, 0.035635)\n        }\n    \n        13.75% {\n            transform: translate(272.23px, 440.214782px) scale(1.228888, 1.228888)\n        }\n    \n        41.25% {\n            transform: translate(272.23px, 440.214782px) scale(0.091157, 0.091157)\n        }\n    \n        100% {\n            transform: translate(272.23px, 440.214782px) scale(0.091157, 0.091157)\n        }\n    }\n    \n    #loader-1-s-circle2_ts {\n        animation: loader-1-s-circle2_ts__ts 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-s-circle2_ts__ts {\n        0% {\n            transform: translate(1128.334792px, 181.854px) scale(0.058455, 0.058455)\n        }\n    \n        70% {\n            transform: translate(1128.334792px, 181.854px) scale(0.058455, 0.058455)\n        }\n    \n        75% {\n            transform: translate(1128.334792px, 181.854px) scale(0.493697, 0.493697)\n        }\n    \n        85% {\n            transform: translate(1128.334792px, 181.854px) scale(0.88886, 0.88886)\n        }\n    \n        97.5% {\n            transform: translate(1128.334792px, 181.854px) scale(0.018289, 0.018289)\n        }\n    \n        100% {\n            transform: translate(1128.334792px, 181.854px) scale(0.018289, 0.018289)\n        }\n    }\n    \n    #loader-1-s-circle3_ts {\n        animation: loader-1-s-circle3_ts__ts 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-s-circle3_ts__ts {\n        0% {\n            transform: translate(1034.957px, 490.76px) scale(-0.054759, -0.054759)\n        }\n    \n        61.25% {\n            transform: translate(1034.957px, 490.76px) scale(-0.054759, -0.054759)\n        }\n    \n        72.5% {\n            transform: translate(1034.957px, 490.76px) scale(-0.818553, -0.818553)\n        }\n    \n        97.5% {\n            transform: translate(1034.957px, 490.76px) scale(-0.027084, -0.027084)\n        }\n    \n        100% {\n            transform: translate(1034.957px, 490.76px) scale(-0.027084, -0.027084)\n        }\n    }\n    \n    #loader-1-s-circle4_ts {\n        animation: loader-1-s-circle4_ts__ts 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-s-circle4_ts__ts {\n        0% {\n            transform: translate(739.227358px, 499.267px) scale(0.086686, 0.086686)\n        }\n    \n        43.25% {\n            transform: translate(739.227358px, 499.267px) scale(0.086686, 0.086686)\n        }\n    \n        46.25% {\n            transform: translate(739.227358px, 499.267px) scale(0.843954, 0.843954)\n        }\n    \n        65% {\n            transform: translate(739.227358px, 499.267px) scale(0.055718, 0.055718)\n        }\n    \n        100% {\n            transform: translate(739.227358px, 499.267px) scale(0.055718, 0.055718)\n        }\n    }\n    \n    #loader-1-s-circle5_ts {\n        animation: loader-1-s-circle5_ts__ts 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-s-circle5_ts__ts {\n        0% {\n            transform: translate(807.507px, 250.356px) scale(0.037088, 0.037088)\n        }\n    \n        45% {\n            transform: translate(807.507px, 250.356px) scale(0.037088, 0.037088)\n        }\n    \n        47.5% {\n            transform: translate(807.507px, 250.356px) scale(1.188035, 1.188035)\n        }\n    \n        70.5% {\n            transform: translate(807.507px, 250.356px) scale(0.040227, 0.040227)\n        }\n    \n        100% {\n            transform: translate(807.507px, 250.356px) scale(0.040227, 0.040227)\n        }\n    }\n    \n    #loader-1-s-circle6_ts {\n        animation: loader-1-s-circle6_ts__ts 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-s-circle6_ts__ts {\n        0% {\n            transform: translate(543.96px, 198.868px) scale(-0.152288, -0.152288)\n        }\n    \n        28.75% {\n            transform: translate(543.96px, 198.868px) scale(-0.152288, -0.152288)\n        }\n    \n        33.875% {\n            transform: translate(543.96px, 198.868px) scale(-0.747354, -0.747354)\n        }\n    \n        53.375% {\n            transform: translate(543.96px, 198.868px) scale(-0.041885, -0.041885)\n        }\n    \n        100% {\n            transform: translate(543.96px, 198.868px) scale(-0.041885, -0.041885)\n        }\n    }\n    \n    #loader-1-s-circle7_ts {\n        animation: loader-1-s-circle7_ts__ts 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-s-circle7_ts__ts {\n        0% {\n            transform: translate(362px, 301.259px) scale(0.063979, 0.063979)\n        }\n    \n        13.75% {\n            transform: translate(362px, 301.259px) scale(0.063979, 0.063979)\n        }\n    \n        20% {\n            transform: translate(362px, 301.259px) scale(1.380506, 1.380505)\n        }\n    \n        48.625% {\n            transform: translate(362px, 301.259px) scale(0.059933, 0.059932)\n        }\n    \n        100% {\n            transform: translate(362px, 301.259px) scale(0.059933, 0.059932)\n        }\n    }\n    \n    #loader-1-s-circle8_ts {\n        animation: loader-1-s-circle8_ts__ts 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-s-circle8_ts__ts {\n        0% {\n            transform: translate(597.467px, 387.802px) scale(0.097074, 0.097074)\n        }\n    \n        33.875% {\n            transform: translate(597.467px, 387.802px) scale(0.097074, 0.097074)\n        }\n    \n        36.25% {\n            transform: translate(597.467px, 387.802px) scale(1.73358, 1.73358)\n        }\n    \n        60% {\n            transform: translate(597.467px, 387.802px) scale(-0.01359, -0.01359)\n        }\n    \n        100% {\n            transform: translate(597.467px, 387.802px) scale(-0.01359, -0.01359)\n        }\n    }\n    \n    #loader-1-s-circle9_ts {\n        animation: loader-1-s-circle9_ts__ts 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-s-circle9_ts__ts {\n        0% {\n            transform: translate(116.452px, 205.808px) scale(0.021473, 0.021473)\n        }\n    \n        2.5% {\n            transform: translate(116.452px, 205.808px) scale(1.252392, 1.252395)\n        }\n    \n        37.5% {\n            transform: translate(116.452px, 205.808px) scale(0.066386, 0.066386)\n        }\n    \n        100% {\n            transform: translate(116.452px, 205.808px) scale(0.066386, 0.066386)\n        }\n    }\n    \n    #loader-1-s-circle10_ts {\n        animation: loader-1-s-circle10_ts__ts 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-s-circle10_ts__ts {\n        0% {\n            transform: translate(859.452px, 383.295px) scale(0.052105, 0.052105)\n        }\n    \n        47.5% {\n            transform: translate(859.452px, 383.295px) scale(0.052105, 0.052105)\n        }\n    \n        63.75% {\n            transform: translate(859.452px, 383.295px) scale(1.218668, 1.218668)\n        }\n    \n        87.5% {\n            transform: translate(859.452px, 383.295px) scale(0.054, 0.054)\n        }\n    \n        100% {\n            transform: translate(859.452px, 383.295px) scale(0.054, 0.054)\n        }\n    }\n    \n    #loader-1-u-bee_to {\n        animation: loader-1-u-bee_to__to 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-u-bee_to__to {\n        0% {\n            offset-distance: 0%\n        }\n    \n        15.75% {\n            offset-distance: 18.458343%\n        }\n    \n        34.875% {\n            offset-distance: 36.648888%\n        }\n    \n        55.625% {\n            offset-distance: 56.451111%\n        }\n    \n        71% {\n            offset-distance: 71.141597%\n        }\n    \n        82.875% {\n            offset-distance: 82.485581%\n        }\n    \n        99.375% {\n            offset-distance: 100%\n        }\n    \n        100% {\n            offset-distance: 100%\n        }\n    }\n    \n    #loader-1-u-bee_tr {\n        animation: loader-1-u-bee_tr__tr 8000ms linear infinite normal forwards\n    }\n    \n    @keyframes loader-1-u-bee_tr__tr {\n        0% {\n            transform: rotate(118.65774deg)\n        }\n    \n        1.25% {\n            transform: rotate(122.202405deg)\n        }\n    \n        3.5% {\n            transform: rotate(115.372827deg)\n        }\n    \n        5.75% {\n            transform: rotate(109.358274deg)\n        }\n    \n        11.875% {\n            transform: rotate(70.265522deg)\n        }\n    \n        13.5% {\n            transform: rotate(57.596306deg)\n        }\n    \n        15.75% {\n            transform: rotate(45.92046deg)\n        }\n    \n        17.125% {\n            transform: rotate(40.69934deg)\n        }\n    \n        18% {\n            transform: rotate(38.696902deg)\n        }\n    \n        20.375% {\n            transform: rotate(35.180438deg)\n        }\n    \n        26.125% {\n            transform: rotate(39.907673deg)\n        }\n    \n        29.875% {\n            transform: rotate(60.940169deg)\n        }\n    \n        34% {\n            transform: rotate(83.531393deg)\n        }\n    \n        38.75% {\n            transform: rotate(121.711444deg)\n        }\n    \n        42.25% {\n            transform: rotate(138.523398deg)\n        }\n    \n        48.625% {\n            transform: rotate(135.099299deg)\n        }\n    \n        50.125% {\n            transform: rotate(126.406147deg)\n        }\n    \n        53.375% {\n            transform: rotate(79.459502deg)\n        }\n    \n        57% {\n            transform: rotate(40.496824deg)\n        }\n    \n        57.25% {\n            transform: rotate(35.479916deg)\n        }\n    \n        60.5% {\n            transform: rotate(21.078307deg)\n        }\n    \n        63.875% {\n            transform: rotate(23.165336deg)\n        }\n    \n        65.25% {\n            transform: rotate(30.066083deg)\n        }\n    \n        66.75% {\n            transform: rotate(50.796451deg)\n        }\n    \n        68.75% {\n            transform: rotate(70.467798deg)\n        }\n    \n        72.875% {\n            transform: rotate(112.40962deg)\n        }\n    \n        76% {\n            transform: rotate(174.372809deg)\n        }\n    \n        79.5% {\n            transform: rotate(236.317164deg)\n        }\n    \n        82.375% {\n            transform: rotate(295.031116deg)\n        }\n    \n        85.625% {\n            transform: rotate(374.12056deg)\n        }\n    \n        88.75% {\n            transform: rotate(406.175698deg)\n        }\n    \n        92% {\n            transform: rotate(434.926396deg)\n        }\n    \n        95.75% {\n            transform: rotate(482.621589deg)\n        }\n    \n        100% {\n            transform: rotate(501.210455deg)\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
